
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const SketchToPsd = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/SketchToPSD"
        ogImage="/images/sketch2psd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/SketchToPSD:title")}
        subtitle={t("page/SketchToPSD:subtitle")}
        magicianLogoFile="psd"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "VideoSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <VideoSection
        title={t("page/SketchToPSD:section/videoSection.title")}
        subtitle={t("page/SketchToPSD:section/videoSection.subtitle")}
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/sketch-to-psd-demo.jpg",
        }}
        hasBackground
      />

      <ApiTeaserSection
        title={t("page/SketchToPSD:section/apiTeaser.title")}
        image={{
          src: "/svgs/illustration.svg",
          alt: "Magician with shield",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.start") }),
        }}
        elements={t(
          "page/SketchToPSD:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsGroupLayers"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("section/conversion:badges.supportsAllNativeElements", {
              format: "Sketch",
            }),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "SKETCH",
            image: "/images/sketch-preview.jpg",
            title: "Sketch Demo Preview",
          },
          to: {
            iconType: "PHOTOSHOP",
            image: "/images/photoshop-preview.jpg",
            title: "Photoshop Demo Preview",
          },
        }}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.sketchToPsdPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default SketchToPsd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/sketch-to-psd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  